import React from 'react';

import { Box } from 'components';
import { useIsMobile } from 'hooks';

import { Navigation } from '../Navigation/Navigation';

import { RouterOutlet, useSelector } from 'third-party';

import { appSelectors } from 'selectors';

const SIDEBAR_WIDTH = '16.25rem'; // 260px
const SIDEBAR_COLLAPSED_WIDTH = '4.5rem';

export const MainView = () => {
  const isNavigationCollapsed = useSelector(appSelectors.isNavigationCollapsed);
  const isMobile = useIsMobile();

  return (
    <Box sx={{ display: 'flex', height: '100%', width: '100%' }}>
      {/* Sidebar */}
      <Box
        sx={{
          display: isMobile ? 'none' : 'flex',
          flexDirection: 'column',
          flexShrink: 0,
          width: isNavigationCollapsed
            ? SIDEBAR_COLLAPSED_WIDTH
            : SIDEBAR_WIDTH,
          transition: 'width 0.3s ease-in-out',
          bgcolor: 'background.paper',
          borderRight: '1px solid',
          borderColor: 'divider',
          zIndex: 10,
        }}
      >
        <Navigation />
      </Box>

      {/* Mobile drawer navigation */}
      {isMobile && <Navigation />}

      {/* Main content */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          overflowY: 'auto',
          bgcolor: 'background.default',
          padding: isMobile ? '4.5rem 1rem 1rem' : '1rem 2.5rem 2.5rem 2.5rem',
          transition: 'padding-left 0.3s ease-in-out',
        }}
      >
        <RouterOutlet />
      </Box>
    </Box>
  );
};
